import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import ContentWrapper from '../components/contentwrapper/ContentWrapper'
import { Link } from 'react-router-dom'
import { AiFillDelete, AiFillEdit, AiOutlinePlus } from 'react-icons/ai'
import { activeStatus, fetchHrDataFromSuperAdmin, removeDataFromList } from '../utils/api'
import { toast } from 'react-toastify'
import LoadingSpinner from '../components/LoadingSpinner'
import Swal from 'sweetalert2'

const HR = () => {
    const [hrdata, sethrdata] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const BASE_URLS = "https://backend.satkartar.org/assets/hr/";

    useEffect(() => {
        getHrData();
    }, [])
    const getHrData = () => {
        setIsLoading(true);
        try {
            fetchHrDataFromSuperAdmin('super-admin-all-hr').then((res) => {
                if (res.data.status === 1) {
                    sethrdata(...[res.data.hrdata]);
                    setIsLoading(false)
                }
                else {
                    toast.error("Something Wrongs");
                    setIsLoading(false);
                }
            })
        }
        catch (error) {
            toast.error("Something Wrongs");
            setIsLoading(false);
        }
    }
    const handleHrActive = (hrid) => {
        activeStatus('super-admin-active-hr-status', hrid).then((res) => {
            if (res.data.status === 1) {
                getHrData();
            }
        })
    }
    const handleHrInactive = (hrid) => {
        activeStatus('super-admin-inactive-hr-status', hrid).then((res) => {
            if (res.data.status === 1) {
                getHrData();
            }
        })
    }
    const handleHrRemoveHr = (hrid) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'danger',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
        }).then((result) => {
            if (result.isConfirmed) {
                removeDataFromList('super-admin-remove-hr', hrid).then((res) => {
                    if (res.data.status === 1) {
                        Swal.fire(
                            'Deleted!',
                            'Your file has been deleted.',
                            'success'
                        )
                        getHrData();
                    }
                })
            }
            else if (
                result.dismiss === Swal.DismissReason.cancel
            ) {
                Swal.fire(
                    'Cancelled',
                    'Your imaginary file is safe :)',
                    'error'
                )
            }
        })
    }
    return (
        <div className="hrpage">
            <Helmet>
                <title>SATKARTAR:ADMIN::HR</title>
            </Helmet>

            <ContentWrapper>
                <div className="card hrpages">
                    <h4 className="mb-0 text-uppercase">
                        All HR
                        <Link to="/add-hr" className="btn btn-primary pull-right"><AiOutlinePlus /> Add HR</Link>
                    </h4>
                    <div className="table pagetable table-responsive">
                        <table id="example" className="table table-striped" style={{ width: "100%" }}>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Image</th>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th>Mobile</th>
                                    <th>Last Login</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isLoading ? <LoadingSpinner />
                                    :
                                    hrdata?.map((hrdata, index) => (
                                        <tr key={hrdata?.hr_id}>
                                            <td>{index + 1}</td>
                                            <td><img width="50" height="50" style={{ width: "50px" }} src={BASE_URLS + hrdata?.hr_foto} alt={hrdata?.hr_foto} /></td>
                                            <td>{hrdata?.hr_name}</td>
                                            <td>{hrdata?.hr_email}</td>
                                            <td>{hrdata?.hr_mobile}</td>
                                            <td>{hrdata?.hr_last_login}</td>
                                            <td>
                                                {(() => {
                                                    if (hrdata?.hr_status === "Active") {
                                                        return (
                                                            <span className="badge bg-success hrstatus" onClick={() => handleHrActive(hrdata?.hr_id)}>Active</span>
                                                        )
                                                    }
                                                    else {
                                                        return (
                                                            <span className="badge bg-danger hrstatus" onClick={() => handleHrInactive(hrdata?.hr_id)}>Inactive</span>
                                                        )
                                                    }
                                                })()}
                                            </td>
                                            <td>
                                                <Link to={`/edit-hr/${hrdata?.hr_id}`} className="btnEdit"><AiFillEdit /></Link>
                                                <button className="btnDelete" onClick={() => handleHrRemoveHr(hrdata?.hr_id)}><AiFillDelete /></button>
                                            </td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th>#</th>
                                    <th>Image</th>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th>Mobile</th>
                                    <th>Last Login</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </ContentWrapper>

        </div>
    )
}

export default HR
